import type { RouteComponentProps, match as Match } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';

import { setLanguage } from 'redux/User/actions';

import { defaultLanguage } from 'constants/onboarding/defaultOnboardingData';

import { getLocalizationFromAvailable } from 'helpers/other/commonUtils';

interface MatchParams {
    language?: string;
}

interface SetLocalizationFromParamsProps extends RouteComponentProps<MatchParams> {
    match: Match<MatchParams>;
}

const withSetLocalizationFromParams =
    <P extends object>(
        Component: React.ComponentType<P & SetLocalizationFromParamsProps>
    ): React.ComponentType<P & SetLocalizationFromParamsProps> =>
    (props: P & SetLocalizationFromParamsProps) => {
        const navigatorLanguage = getLocalizationFromAvailable();
        const language = navigatorLanguage || props.match.params.language || defaultLanguage;

        const { i18n } = useTranslation();
        const dispatch = useDispatch();

        useEffect(() => {
            localStorage.setItem('language', language);
            dispatch(setLanguage(language));
            i18n.changeLanguage(language);
        }, [dispatch, i18n, language]);

        return <Component {...props} />;
    };

export default withSetLocalizationFromParams;
